export default async (to, from, next) => {
  //settings
  document.title = process.env.VUE_APP_DOCUMENT_TITLE;

  if (to.name !== from.name) window.scrollTo(0, 0);

  next();
};
